import React, { useState } from "react";
import { NEW_BASE_URL, MessageType } from "../../../../Constant";
import { newReconDownloadExcelAPI } from "../../../../services/APIutils";
import UploadExcelModal from "../../../../shared/components/fileupload/UploadExcelModal";
import { PageWrapper } from "../../../../shared/layout";
import { saveCsvBlob } from "../../../../shared/methods/sharedMethods";
import { Button } from "../../../../shared/widgets";
import _store from "../../../../redux/createStore";

function OndcUpload() {
  const [showUploadModal, setShowUploadModal] = useState(false);
  const store = _store.getState();
  const newCreateFormAndSubmit = ({ uriProps = {}, url }) => {
    newReconDownloadExcelAPI(url, uriProps).then((res) => {
      let fileName = res.headers["content-disposition"]?.split("Filename=")[1];
      fileName = fileName?.replaceAll("\"", "");
      saveCsvBlob({ blob: res.data, fileName });
    });
  };

  const exportSampleUploadSheet = () => {
    newCreateFormAndSubmit({
      uriProps: {
        role: store?.Auth?.user?.role === "Finance" ? "FINANCE" : "CRUT",
      },
      url: `${NEW_BASE_URL}/v1/ondc/exportSampleFile`,
    });
  };
  const toggleUploadModal = (data) => {
    setShowUploadModal(data);
  };

  const displayUploadModal = () => (
    <UploadExcelModal
      showModal={showUploadModal}
      messageCallBack={(type) => {
        if (type === MessageType.SUCCESS || !(type === MessageType.ERROR)) {
          setShowUploadModal(false);
        }
      }}
      uploadType="ondcReport"
    />
  );

  return (
    <div className="pageContainer">
      <PageWrapper>
        <PageWrapper.Header heading={store?.Auth?.user?.role === "Finance" ? "ONDC Buyer Data Upload" : "ONDC Seller Data Upload"} removeFilterOnly="false" hideS>
          <div className="pull-right">
            <a
              className="sample-button"
              role="link"
              tabIndex="0"
              onKeyDown={() => {
                /* onKeyDown */
              }}
              onClick={() => exportSampleUploadSheet()}
            >
              Sample File
            </a>
            <Button
              onClick={() => toggleUploadModal(true)}
              buttonText="Upload"
            />
          </div>
        </PageWrapper.Header>
        {showUploadModal && displayUploadModal()}
      </PageWrapper>
    </div>
  );
}

export default OndcUpload;
